export const categories = [
  { id: "hongtao", name: "红桃视频", slug: "hongtao", color: "from-red-500/80 to-rose-600/80", description: "热血激情的红桃系列，涵盖动作、冒险、战争题材影片" },
  { id: "heitao", name: "黑桃视频", slug: "heitao", color: "from-gray-700/80 to-gray-900/80", description: "深沉神秘的黑桃系列，悬疑、惊悚、犯罪题材精选" },
  { id: "taohua", name: "桃花视频", slug: "taohua", color: "from-pink-400/80 to-pink-600/80", description: "浪漫温馨的桃花系列，爱情、家庭、生活剧集" },
  { id: "hongxing", name: "红杏视频", slug: "hongxing", color: "from-orange-400/80 to-red-500/80", description: "热情奔放的红杏系列，青春、校园、成长故事" },
  { id: "tangxin", name: "糖心视频", slug: "tangxin", color: "from-amber-300/80 to-yellow-500/80", description: "甜蜜治愈的糖心系列，喜剧、动画、轻松娱乐" },
  { id: "douhua", name: "豆花视频", slug: "douhua", color: "from-emerald-400/80 to-teal-600/80", description: "清新淡雅的豆花系列，文艺、纪录、人文佳作" },
  { id: "fentao", name: "粉桃视频", slug: "fentao", color: "from-fuchsia-400/80 to-purple-500/80", description: "甜美可爱的粉桃系列，少女向、奇幻、治愈动画" },
  { id: "baitao", name: "白桃视频", slug: "baitao", color: "from-slate-300/80 to-slate-500/80", description: "纯净简约的白桃系列，经典老片、黑白电影、独立作品" },
  { id: "zitao", name: "紫桃视频", slug: "zitao", color: "from-violet-400/80 to-indigo-600/80", description: "神秘优雅的紫桃系列，科幻、奇幻、超自然题材" },
  { id: "lantao", name: "蓝桃视频", slug: "lantao", color: "from-sky-400/80 to-cyan-600/80", description: "深邃广袤的蓝桃系列，海洋、自然、探险纪录片" },
];

export const featuredVideos = [
  {
    id: "v1",
    title: "春风十里不如你",
    category: "桃花视频",
    categorySlug: "taohua",
    image: "https://readdy.ai/api/search-image?query=Romantic%20Chinese%20period%20drama%20scene%20with%20cherry%20blossom%20trees%20and%20couple%20walking%20in%20traditional%20clothing%2C%20warm%20spring%20sunset%20lighting%2C%20soft%20cinematic%20film%20look%2C%20clean%20minimalist%20composition&width=600&height=400&seq=video-01&orientation=landscape",
    rating: 9.2,
    views: "128万",
    year: "2025",
    type: "电视剧",
    description: "一段发生在江南水乡的浪漫爱情故事，青梅竹马，兜兜转转，最终追寻到彼此内心最深处的情感。",
    url: "/article/1",
  },
  {
    id: "v2",
    title: "暗夜追踪者",
    category: "黑桃视频",
    categorySlug: "heitao",
    image: "https://readdy.ai/api/search-image?query=Noir%20thriller%20scene%20with%20detective%20walking%20through%20rainy%20city%20street%20at%20night%2C%20dark%20moody%20atmosphere%20with%20neon%20reflections%2C%20cinematic%20lighting%2C%20suspenseful%20tone%2C%20professional%20film%20still&width=600&height=400&seq=video-02&orientation=landscape",
    rating: 8.8,
    views: "96万",
    year: "2026",
    type: "电影",
    description: "一位退休刑警为追查旧案再度出山，在黑暗中寻找真相，层层揭开惊人内幕。",
    url: "/article/2",
  },
  {
    id: "v3",
    title: "星际迷航：新纪元",
    category: "紫桃视频",
    categorySlug: "zitao",
    image: "https://readdy.ai/api/search-image?query=Futuristic%20space%20exploration%20scene%20with%20spaceship%20approaching%20distant%20galaxy%2C%20vibrant%20nebula%20colors%20with%20stars%2C%20epic%20cinematic%20scope%2C%20high%20contrast%20lighting%2C%20clean%20composition%20with%20minimal%20elements&width=600&height=400&seq=video-03&orientation=landscape",
    rating: 9.0,
    views: "215万",
    year: "2026",
    type: "电影",
    description: "人类文明迈入星际时代，一支探险队发现宇宙深处的神秘信号，开启了前所未有的冒险。",
    url: "/article/3",
  },
  {
    id: "v4",
    title: "欢乐一家人",
    category: "糖心视频",
    categorySlug: "tangxin",
    image: "https://readdy.ai/api/search-image?query=Warm%20family%20comedy%20scene%20with%20Chinese%20family%20laughing%20together%20in%20bright%20modern%20living%20room%2C%20sunny%20natural%20daylight%2C%20cozy%20happy%20atmosphere%2C%20clean%20minimal%20composition%2C%20cinematic%20still&width=600&height=400&seq=video-04&orientation=landscape",
    rating: 9.5,
    views: "356万",
    year: "2025",
    type: "电视剧",
    description: "三代同堂的欢乐日常，每个小故事都充满笑声与感动，温暖治愈你的每一天。",
    url: "/article/4",
  },
  {
    id: "v5",
    title: "青春不散场",
    category: "红杏视频",
    categorySlug: "hongxing",
    image: "https://readdy.ai/api/search-image?query=Youth%20campus%20scene%20with%20students%20running%20on%20playground%20under%20golden%20sunset%2C%20nostalgic%20warm%20lighting%2C%20friendship%20and%20freedom%20vibe%2C%20cinematic%20composition%2C%20clean%20aesthetic&width=600&height=400&seq=video-05&orientation=landscape",
    rating: 8.6,
    views: "187万",
    year: "2025",
    type: "电影",
    description: "高中毕业十年后，七个好友重聚校园，回忆那些年一起追过的梦与爱。",
    url: "/article/5",
  },
  {
    id: "v6",
    title: "烈火雄心",
    category: "红桃视频",
    categorySlug: "hongtao",
    image: "https://readdy.ai/api/search-image?query=Heroic%20firefighter%20scene%20with%20brave%20rescue%20operation%20in%20burning%20building%2C%20dramatic%20warm%20orange%20flames%20and%20smoke%2C%20intense%20action%20moment%2C%20cinematic%20film%20look%2C%20professional%20composition&width=600&height=400&seq=video-06&orientation=landscape",
    rating: 9.1,
    views: "278万",
    year: "2026",
    type: "电视剧",
    description: "城市消防员的真实日常，每一次出警都是与时间赛跑，用生命守护生命。",
    url: "/article/6",
  },
  {
    id: "v7",
    title: "蓝色星球之旅",
    category: "蓝桃视频",
    categorySlug: "lantao",
    image: "https://readdy.ai/api/search-image?query=Underwater%20ocean%20documentary%20scene%20with%20diverse%20marine%20life%20coral%20reef%2C%20sunlight%20penetrating%20clear%20blue%20water%2C%20peaceful%20nature%20vibe%2C%20cinematic%20wide%20shot%2C%20clean%20simple%20composition&width=600&height=400&seq=video-07&orientation=landscape",
    rating: 9.3,
    views: "142万",
    year: "2025",
    type: "纪录片",
    description: "探索海洋深处的奇迹，从珊瑚礁到深海热泉，一场震撼心灵的蓝色之旅。",
    url: "/article/7",
  },
  {
    id: "v8",
    title: "古韵长安",
    category: "豆花视频",
    categorySlug: "douhua",
    image: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20city%20scene%20with%20traditional%20architecture%20and%20lanterns%20at%20dusk%2C%20warm%20golden%20lighting%2C%20historical%20cultural%20atmosphere%2C%20cinematic%20wide%20shot%2C%20clean%20elegant%20composition&width=600&height=400&seq=video-08&orientation=landscape",
    rating: 9.4,
    views: "89万",
    year: "2026",
    type: "纪录片",
    description: "以长安城为背景，讲述千年古都的文化传承与历史变迁，带你穿越时空。",
    url: "/article/8",
  },
];

export const latestVideos = [
  {
    id: "n1",
    title: "迷雾之城 第二季",
    category: "黑桃视频",
    categorySlug: "heitao",
    image: "https://readdy.ai/api/search-image?query=Foggy%20cityscape%20skyline%20with%20mysterious%20atmosphere%2C%20detective%20genre%20feel%2C%20dark%20muted%20tones%2C%20cinematic%20noir%20lighting%2C%20clean%20minimal%20composition&width=400&height=280&seq=latest-01&orientation=landscape",
    rating: 8.7,
    year: "2026",
    type: "电视剧",
    episode: "更新至第8集",
  },
  {
    id: "n2",
    title: "樱花庄的约定",
    category: "桃花视频",
    categorySlug: "taohua",
    image: "https://readdy.ai/api/search-image?query=Japanese%20style%20garden%20with%20cherry%20blossom%20trees%20and%20wooden%20house%2C%20soft%20spring%20sunlight%2C%20romantic%20peaceful%20atmosphere%2C%20cinematic%20clean%20composition&width=400&height=280&seq=latest-02&orientation=landscape",
    rating: 9.0,
    year: "2026",
    type: "电影",
    episode: "HD高清",
  },
  {
    id: "n3",
    title: "机甲战士：重生",
    category: "紫桃视频",
    categorySlug: "zitao",
    image: "https://readdy.ai/api/search-image?query=Futuristic%20mecha%20robot%20standing%20in%20neon%20lit%20cityscape%20at%20night%2C%20sci-fi%20action%20genre%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20clean%20minimal%20design&width=400&height=280&seq=latest-03&orientation=landscape",
    rating: 8.5,
    year: "2026",
    type: "电影",
    episode: "HD高清",
  },
  {
    id: "n4",
    title: "心动的信号 第四季",
    category: "红杏视频",
    categorySlug: "hongxing",
    image: "https://readdy.ai/api/search-image?query=Young%20couple%20sitting%20on%20park%20bench%20at%20golden%20hour%2C%20romantic%20dating%20vibe%2C%20warm%20sunset%20lighting%2C%20cinematic%20clean%20look%2C%20natural%20composition&width=400&height=280&seq=latest-04&orientation=landscape",
    rating: 8.9,
    year: "2026",
    type: "综艺",
    episode: "更新至第6期",
  },
  {
    id: "n5",
    title: "舌尖上的家乡",
    category: "豆花视频",
    categorySlug: "douhua",
    image: "https://readdy.ai/api/search-image?query=Chinese%20traditional%20food%20cooking%20scene%20with%20steaming%20hot%20dishes%20on%20wooden%20table%2C%20warm%20kitchen%20lighting%2C%20appetizing%20atmosphere%2C%20clean%20minimal%20composition%2C%20documentary%20style&width=400&height=280&seq=latest-05&orientation=landscape",
    rating: 9.6,
    year: "2026",
    type: "纪录片",
    episode: "全12集",
  },
  {
    id: "n6",
    title: "欢乐喜剧人 第八季",
    category: "糖心视频",
    categorySlug: "tangxin",
    image: "https://readdy.ai/api/search-image?query=Comedy%20stage%20performance%20with%20bright%20colorful%20lighting%20and%20audience%20laughing%2C%20energetic%20fun%20atmosphere%2C%20warm%20spotlight%2C%20clean%20theatrical%20composition&width=400&height=280&seq=latest-06&orientation=landscape",
    rating: 8.4,
    year: "2026",
    type: "综艺",
    episode: "更新至第10期",
  },
];

export const banners = [
  {
    id: "b1",
    title: "烈火雄心 — 热血救援 燃情上映",
    description: "年度最燃救援大片，见证平凡英雄的非凡时刻",
    image: "https://readdy.ai/api/search-image?query=Heroic%20firefighter%20silhouette%20against%20dramatic%20orange%20sunset%20sky%20with%20smoke%20and%20embers%2C%20epic%20cinematic%20scale%2C%20warm%20golden%20atmospheric%20lighting%2C%20abstract%20artistic%20style%2C%20minimal%20composition%20with%20strong%20contrast%20and%20emotional%20impact&width=1600&height=700&seq=hero-banner-01&orientation=landscape",
    category: "红桃视频",
    url: "/article/6",
  },
  {
    id: "b2",
    title: "蓝色星球之旅 — 深海奇迹",
    description: "探索海洋深处的无尽奥秘，每一帧都震撼心灵",
    image: "https://readdy.ai/api/search-image?query=Deep%20blue%20ocean%20with%20sunlight%20rays%20penetrating%20water%20surface%20and%20marine%20life%20silhouettes%2C%20peaceful%20vast%20underwater%20landscape%2C%20abstract%20artistic%20style%2C%20minimal%20composition%20with%20gradient%20teal%20tones&width=1600&height=700&seq=hero-banner-02&orientation=landscape",
    category: "蓝桃视频",
    url: "/article/7",
  },
  {
    id: "b3",
    title: "古韵长安 — 千年回响",
    description: "一座城，千年史，穿越时空的文化盛宴",
    image: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20architecture%20silhouette%20at%20dusk%20with%20warm%20lantern%20glow%20and%20misty%20atmosphere%2C%20historical%20cultural%20mood%2C%20abstract%20artistic%20composition%2C%20minimal%20elegant%20style%20with%20soft%20warm%20amber%20and%20gold%20tones&width=1600&height=700&seq=hero-banner-03&orientation=landscape",
    category: "豆花视频",
    url: "/article/8",
  },
];